import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAccess } from '../../../hooks/useAccess';
import { Paths } from '../../../shared/paths';
import { SupportInnerTabs } from './SupportInnerTabs';

export default function Support() {
  const { access } = useAccess();
  const canView = access?.supportRequests?.canView ?? false;

  if (!canView) {
    return <Navigate to={Paths.root} replace />;
  }

  return <SupportInnerTabs />;
}
